<template>
  <div class="suggestion-wrapper">
    <div class="feedback-modal" v-if="isShow" @touchmove.prevent>
      <div class="feedback-wrapper">
        <img src="../assets/images/popup_close@3x.png" @click="closeModal">
        <h2>请选择您反馈的类型（可多选）</h2>
        <ul class="feedback-type">
          <li>
            <p>咨询：</p>
            <ul class="items">
              <li class="btn" :class="{'active':tags.indexOf('30')>-1}"
                @click="selectTags('30')">咨询恢复场景</li>
            </ul>
          </li>
          <li>
            <p>投诉：</p>
            <ul class="items">
              <li class="btn" :class="{'active':tags.indexOf('40')>-1}"
                @click="selectTags('40')">对恢复效果不满意</li>
              <li class="btn" :class="{'active':tags.indexOf('41')>-1}"
                @click="selectTags('41')">对服务工程师不满意</li>
              <li class="btn" :class="{'active':tags.indexOf('42')>-1}"
                @click="selectTags('42')">对服务流程有疑虑</li>
            </ul>
          </li>
          <li>
            <p>建议：</p>
            <ul class="items">
              <li class="btn" :class="{'active':tags.indexOf('反馈App的问题')>-1}"
                @click="selectTags('反馈App的问题')">反馈App的问题</li>
            </ul>
          </li>
        </ul>
        <div class="btns">
          <div class="ok-btn" @click="feedback('normal')">确定</div>
          <p class="skip-btn" @click="feedback('skip')">以上类型都不是/跳过</p>
        </div>
      </div>
    </div>
    <div class="main-wrapper">
      <mt-header fixed title="意见反馈" style="background:#ffffff;color:#262626;">
        <router-link to="/my" slot="left">
          <mt-button icon="back"></mt-button>
        </router-link>
      </mt-header>

      <div class="main-content" v-if="!tipStatus">
        <ul class="menu">
          <li @click="goArticle(question_url, '常见问题')">
            <div>
              <p>常见问题</p>
              <span>详细说明了恢复原理、支持的数据项等</span>
            </div>
            <img src="../assets/images/global_more_arrow@3x.png">
          </li>
          <li @click="goArticle(flow_url,'服务流程')">
            <div>
              <p>服务流程</p>
              <span>详细介绍了服务流程、收费标准等信息</span>
            </div>
            <img src="../assets/images/global_more_arrow@3x.png">
          </li>
          <a href="mailto:guoshixiongkefu@163.com">
            <li>
              <div>
                <p>投诉邮箱</p>
                <span>guoshixiongkefu@163.com</span>
              </div>
              <img src="../assets/images/global_more_arrow@3x.png">
            </li>
          </a>
        </ul>

        <div class="feedback">
          <p>问题反馈</p>
          <div class="content">
            <textarea placeholder="请在此输入您需要反馈的内容" v-model="suggestion"></textarea>
          </div>
        </div>

        <div class="submit" v-if="valid" @click="openModal">
          提交
        </div>
        <div class="submit disabled" v-if="!valid">
          提交
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
    name:"suggestion",
    metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
      return {
        tipStatus: false,
        isShow: false,
        suggestion: '',
        valid: false,
        tags: [],
        app_id: window.config.app_id,
        question_url: window.config.API_URL1+'/apph5/page/question?app_id='+window.config.appid,
        flow_url: window.config.API_URL1+'/apph5/page/summary?app_id='+window.config.appid
      }
    },
    created(){
    },
    mounted(){
    },
    methods:{
      selectTags(tag){
        let index = this.tags.indexOf(tag)
        if(index>-1){
          this.tags.splice(index,1)
        }else {
          this.tags.push(tag)
        }
      },
      goArticle(url,title){
        this.$router.push({name:"article",query:{url:url,title:title}})
      },
      closeModal(){
        this.isShow = false
      },
      openModal(){
        this.isShow = true
      },
      feedback(type){
        let vm = this;
        let access_token = localStorage.access_token;
        let data= {
          info:{
            tags: type=='skip'?'':this.tags.join(','),
            content: vm.suggestion.replace(/\s+/g, ""),
            type:1,
            app_id:window.config.appid
          },
          access_token: access_token
        };
        
        this.$store.dispatch("feedback",data).then((res)=>{
          if(res.data.code == 0){
             vm.$router.replace({name:"suggestion_next",query:{feedback_id:res.data.res.feedback_id}})
          }
        })
       
      }
      
    },
    watch: {
      suggestion(val){
        if(this.suggestion == ''){
          this.valid=false;
        }else{
          this.valid=true;
        }
      }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Suggestion.vue